import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Space, Typography, Tag, Empty } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { TrainingsApi } from '../../Api/TrainingsApi';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import { FaArrowLeft } from 'react-icons/fa6';
import style from '../../Styles/AddUser.module.css';

const { Title, Text } = Typography;

const TraineeFeedback = () => {
  const [selectedRatings, setSelectedRatings] = useState({});
  const [hoveredBox, setHoveredBox] = useState(null);
  const [feedbackData, setFeedbackData] = useState(null);
  const [hasFeedback, setHasFeedback] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { authState } = useAuth();

  const training_id =
    location?.state?.training_id ||
    location?.state?.overviewData?.training_details?.id;

  const trainee_id = authState?.id;

  const getFeedbackData = async () => {
    try {
      const payload = {
        training_id: training_id,
        trainee_id: trainee_id,
      };

      const res = await TrainingsApi.getTraineeFeedback(payload);

      const data = res?.data?.result?.[0];

      if (data) {
        setFeedbackData(data);
        setHasFeedback(true);

        const ratingObj = {};
        const questionsArr = data?.response?.questions || [];
        
        questionsArr.forEach((q, qIndex) => {
          if (q.type === 'rating_group' && q.ratings) {
            q.ratings.forEach((rate, rIndex) => {
              ratingObj[`${qIndex}-${rIndex}`] = rate.value;
            });
          }
        });

        setSelectedRatings(ratingObj);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getFeedbackData();
    window.scrollTo(0, 0);
  }, []);

  const getColors = (num) => {
    if (num <= 3) return { text: '#f87171', active: '#ef4444' };
    if (num <= 6) return { text: '#fbbf24', active: '#f97316' };
    if (num === 7) return { text: '#86efac', active: '#4ade80' };
    if (num <= 9) return { text: '#4ade80', active: '#22c55e' };

    return { text: '#15803d', active: '#15803d' };
  };

  const getBoxStyle = (boxKey, num) => {
    const isSelected = selectedRatings[boxKey] === num;
    const isHovered = hoveredBox === `${boxKey}-${num}`;
    const { text, active } = getColors(num);

    return {
      width: '38px',
      height: '38px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #e2e8f0',
      borderRadius: '4px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      backgroundColor: isSelected || isHovered ? active : '#fff',
      color: isSelected || isHovered ? '#fff' : text,
      borderColor: isSelected || isHovered ? active : '#e2e8f0',
      transform: isHovered ? 'translateY(-2px)' : 'none',
    };
  };

  const questionStyle = {
    fontSize: '16px',
    color: '#334155',
    fontWeight: '700',
    display: 'block',
    marginBottom: '8px',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  };

  const answerStyle = {
    color: '#64748b',
    fontSize: '14px',
    fontWeight: '400',
    marginBottom: '32px',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  };

  const questions = feedbackData?.response?.questions || [];

  return (
    <div
      style={{
        background: '#fff',
      
        padding: '30px 40px',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {!hasFeedback ? (
          <div style={{ padding: '60px 0', display: 'flex', justifyContent: 'center' }}>
            <Empty description="Feedback not available" />
          </div>
        ) : (
          <>
          {/* RENDER QUESTIONS IN ORDER */}
          {questions
            .sort((a, b) => a.question_no - b.question_no)
            .map((item, index) => {
              if (item.type === 'text') {
                return (
                  <div key={index} style={{ marginBottom: 30 }}>
                    <Text style={questionStyle}>
                      {item.question_no}. {item.question}
                    </Text>
                    <p style={answerStyle}>
                      {item.answer || '--'}
                    </p>
                  </div>
                );
              }

              if (item.type === 'rating_group') {
                return (
                  <div key={index} style={{ marginBottom: '40px' }}>
                    <Text
                      style={{
                        ...questionStyle,
                        fontSize: '17px',
                        marginBottom: '25px',
                      }}
                    >
                      {item.question_no}. {item.question}
                    </Text>

                    <div style={{ borderTop: '1px solid #f1f5f9' }}>
                      {item.ratings.map((rate, rowIndex) => (
                        <Row
                          key={rowIndex}
                          align="middle"
                          justify="space-between"
                          style={{
                            padding: '14px 0',
                            borderBottom: '1px solid #f1f5f9',
                          }}
                        >
                          <Col>
                            <Text
                              style={{
                                color: '#64748b',
                                fontSize: '14px',
                                fontWeight: '500',
                              }}
                            >
                              {rate.label}
                            </Text>
                          </Col>

                          <Col>
                            <Space size={8}>
                              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                                <div
                                  key={num}
                                  onMouseEnter={() =>
                                    setHoveredBox(`${index}-${rowIndex}-${num}`)
                                  }
                                  onMouseLeave={() => setHoveredBox(null)}
                                  style={getBoxStyle(`${index}-${rowIndex}`, num)}
                                >
                                  {num}
                                </div>
                              ))}
                            </Space>
                          </Col>
                        </Row>
                      ))}
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </>
        )}
      </div>
    </div>
  );
};

export default TraineeFeedback;